import TermContainer from "./TermsContainer";
export default TermContainer;
